import React from "react";
import { connect } from "react-redux";

import { HubFilterMenu, useRolesHookFormList } from "../../components";
import { getUserLocation } from "../../redux";

const OrganizationRoleFilter = ({ locationId = 1, ...rest }) => {
  const { roles = [] } = useRolesHookFormList({ locationId });
  const labels = roles?.map((r) => ({ id: r.id, label: r.name }));

  return (
    <HubFilterMenu
      id="role"
      options={labels}
      menuLabel="Filter Users by Role"
      label="User Role"
      useDefault={false}
      {...rest}
    />
  );
};

const mapStateToProps = (state) => ({
  locationId: getUserLocation(state),
});
export default connect(mapStateToProps)(OrganizationRoleFilter);
